module.exports = __webpack_public_path__ + "static/media/Jace-4row.a668d826.png";